import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VinSights } from '../../interfaces/vinsights';
import {
  trigger,
  transition,
  style,
  animate
} from '@angular/animations';

@Component({
    selector: 'lib-vinsight-details',
    templateUrl: './vinsight-details.component.html',
    styleUrl: './vinsight-details.component.css',
    animations: [
        trigger('fadeDone', [
            transition(':leave', [
                animate('300ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VinSightDetailsComponent {
  counterIcons = ['counter_1', 'counter_2', 'counter_3', 'counter_4', 'counter_5'];
  animated: boolean[] = [];
  loading = true;
  showDoneIcon = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VinSights) {}

  onRevealDone() {
    this.loading = false;
    this.showDoneIcon = true;

    setTimeout(() => {
      this.showDoneIcon = false;
    }, 2000);
  }
}
